import { NumberValueFormatter } from '@gogame/intl-ts';

import {
  VALUE_TYPE_NUMBER,
  VALUE_TYPE_CURRENCY,
  VALUE_TYPE_PERCENT,
} from './ComposedChart/constants';

export const MetricValueFormatter = ({ value, type }) => {
  const intValue = parseInt(`${value}`) || 0;

  let precision = 2;

  if (intValue) {
    switch (`${intValue}`.length) {
      case 4:
      case 7:
      case 10:
      case 13:
        precision = 1;
        break;
      default:
        precision = 0;
        break;
    }
  }

  switch (type) {
    case VALUE_TYPE_NUMBER:
      return (
        <NumberValueFormatter.Decimal
          value={value}
          precision={precision}
          notation={'compact'}
        />
      );
    case VALUE_TYPE_CURRENCY:
      return (
        <NumberValueFormatter.Currency
          value={value}
          precision={precision}
          notation={'compact'}
          currency={'USD'}
        />
      );
    case VALUE_TYPE_PERCENT:
      return <NumberValueFormatter.Percent value={value} precision={2} />;
    default:
      return value;
  }
};
export default MetricValueFormatter;
